const initialState = {
  isLoading: false,
  error: null,
  bankingDetails: null,
};

export default function bankingDetailsReducer(
  state = initialState,
  action = {},
) {
  switch (action.type) {
    case 'GET_BANKING_DETAILS_REQUEST': {
      return {
        ...state,
        isLoading: true,
      };
    }
    case 'GET_BANKING_DETAILS_FAILURE': {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    }
    case 'GET_BANKING_DETAILS_SUCCESS': {
      const {
        account_number: accountNumber,
        sort_code: sortCode,
        account_name: accountName,
        bic,
        iban,
        local_bank_code: localBankCode,
      } = action.payload;
      return {
        ...state,
        bankingDetails: {
          accountNumber,
          sortCode,
          accountName,
          bic,
          iban,
          localBankCode,
        },
        error: null,
        isLoading: false,
      };
    }
    default:
      return state;
  }
}
